import {
  Form,
  Input,
  Select,
  Row,
  Col,
  message,
  Modal,
  Switch,
  Drawer,
  Space,
  Button,
  InputNumber,
  Tooltip, Spin,
} from 'antd';
import { useEffect, useState, useRef } from 'react';
import styles from '../../index.module.less';
import {
  addActivityProduct,
  getActivityProductType,
  getPromoType,
  getPromoStyle,
  getActivityProductLimitType,
  getActivityProductPmsLimitType,
  getActiveCostBelong,
  getProductSkuList,
  updateActivityProduct, getProductManagementPage
} from '@/services/product';
import DebounceSearchSelect from "@/pages/baseProduct/components/DebounceSearchSelect";

const { Option } = Select;

const AddOrEditForm = (props: any) => {
  const [form] = Form.useForm();
  const inputRef = useRef<any>(null);
  const { id, show, listRef, setVisible, editData, pid } = props;
  const [activityType, setActivityType] = useState([]); //activeCostBelongCode
  const [promoType, setPromoType] = useState([]);
  const [promoTypeValue, setPromoTypeValue] = useState('');
  const [activityProductType, setActivityProductType] = useState('');
  const [promoStyle, setPromoStyle] = useState([]);
  const [limitType, setLimitType] = useState([]);
  const [pmLimitType, setPmLimitType] = useState([]);
  const [activeCostBelongCode, setActiveCostBelongCode] = useState([]);
  const [skuList, setSkuList] = useState([]);
  const [limitTypeValue, setLimitTypeValue] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.log(editData);
    form.setFieldsValue(editData);
    setPromoTypeValue(editData?.promoType)
    setActivityProductType(editData?.activityProductType)
    // 设置限制类型
    setLimitTypeValue(editData?.limitType);
  }, [editData]);

  useEffect(() => {
    getDict();
  }, []);

  const onFinish = async (values) => {
    var data = {};
    if (!values.activityProductType) {
      message.error('请选择活动类型');
      return false;
    }
    data.activityProductType = values.activityProductType;

    if (!values.skuId) {
      message.error('请选择活动产品SKU');
      return false;
    }
    data.skuId = values.skuId;

    if (!values.promoType) {
      message.error('请选择优惠类型');
      return false;
    }
    data.promoType = values.promoType;
    if (!values.promoStyle) {
      message.error('请选择优惠形式');
      return false;
    }
    data.promoStyle = values.promoStyle;
    if (values.salePrice === '') {
      message.error('请输入销售价格');
      return false;
    }
    data.salePrice = values.salePrice;
    if (!values.sendPackageRule) {
      message.error('请输入发包规则');
      return false;
    }
    data.sendPackageRule = values.sendPackageRule;
    if (!values.limitType) {
      message.error('请选择限制类型');
      return false;
    }
    data.limitType = values.limitType;
    if (values.limitType != 'UNLIMITED' && !values.limitValue) {
      message.error('请输入限制值');
      return false;
    }

    data.limitValue = values.limitValue;
    if (!values.pmsLimitType) {
      message.error('请选择交付限制类型');
      return false;
    }
    data.pmsLimitType = values.pmsLimitType;
    if (!values.costBelong) {
      message.error('请选择活动成本归属');
      return false;
    }
    if(values.promoType === 'DISCOUNT_COUPON'){
      if (!values.deductionProductIds?.length) {
        message.error('请选择可抵扣的产品');
        return false;
      }
      data.deductionProductIds = values.deductionProductIds;
      if (!values.deductionLimitValue) {
        message.error('请输入最高抵扣金额');
        return false;
      }
      data.deductionLimitValue = values.deductionLimitValue;
    }
    //报价模板id需要处理成逗号分割

    console.log(values);
    data.costBelong = values.costBelong;
    data.required = values.required;
    data.merchActivitiesId = pid;
    data.minLimit = values.minLimit;
    data.maxLimit = values.maxLimit;
    data.remark = values.remark;
    data.activityId = pid;
    if (id) {
      data.id = id;
      const res: any = await updateActivityProduct(data);
      if (res.id) {
        message.success('编辑成功');
        setVisible(false);
        listRef?.current?.reload();
      }
    } else {
      const res: any = await addActivityProduct(data)
      if (res.id) {
        message.success('新增成功');
        setVisible(false);
        listRef?.current?.reload();
      }
    }
  };

  const getDict = async () => {
    setLoading(true)
    const res: any = await Promise.all([
      getActivityProductType(),
      getPromoType(),
      getPromoStyle(),
      getActivityProductLimitType(),
      getActivityProductPmsLimitType(),
      getActiveCostBelong(),
      getProductSkuList({ enabled: true }), // 只查询启用的SKU
    ]).finally(() => setLoading(false))
    if (res?.length) {
      setActivityType(res[0] || []);
      setPromoType(res[1] || []);
      setPromoStyle(res[2] || []);
      setLimitType(res[3] || []);
      setPmLimitType(res[4] || []);
      setActiveCostBelongCode(res[5] || []);
      const newSkuList = res[6]?.map((sku: any) => ({ value: sku.id, label: sku.id + '_' + sku.skuName }));
      setSkuList(newSkuList);
    }
  };
  const closeModal = () => {
    setVisible(false);
  };
  const onSubmit = () => {
    form.submit();
  };
  return (
    <Drawer
      title={id ? '编辑' : '新增'}
      width={'45%'}
      onClose={closeModal}
      bodyStyle={{ padding: 15 }}
      visible={show}
      destroyOnClose={true}
      footer={
        <Space style={{ float: 'right' }}>
          <Button onClick={closeModal} disabled={loading}>取消</Button>
          <Button onClick={onSubmit} type="primary" disabled={loading}>
            保存
          </Button>
        </Space>
      }
    >
      <Spin spinning={loading}>
      <div className={styles.case_content}>
        <Form preserve={false} className={styles.form_content} name="validate_other" onFinish={onFinish} form={form} layout="vertical">
          <Row>
            <Col span={24}>
              <Form.Item
                name="activityProductType"
                label="活动类型"
                className={`${styles.case_item} ${styles.case_label_required}`}
              >
                <Select placeholder="请选择" className={styles.case_item_select} onChange={(value) => {
                  if (value) {
                    form.setFieldValue('promoType', null)
                    setPromoTypeValue( null)
                  }
                  setActivityProductType(value)
                }}>
                  {activityType.map((item, index) => (
                    <Option key={item.key} value={item.key}>
                      {item.description}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                name="skuId"
                label="活动产品SKU"
                className={`${styles.case_item} ${styles.case_label_required}`}
              >
                <Select
                  placeholder="请选择"
                  showSearch
                  allowClear
                  className={styles.case_item_select}
                  filterOption={(input, option) =>
                    {
                      return (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                  }
                >
                  {skuList.map((item, index) => (
                    <Option key={item.value} value={item.value}>
                      {item.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                name="promoType"
                label="优惠类型"
                className={`${styles.case_item} ${styles.case_label_required}`}
              >
                <Select placeholder="请选择" className={styles.case_item_select}
                        onChange={(value) => {
                          setPromoTypeValue(value);
                          if (id && value === 'DISCOUNT_COUPON') {
                            console.log(111)
                            form.setFieldValue('deductionProductIds', editData?.deductionProductIds);
                            form.setFieldValue('deductionLimitValue', editData?.deductionLimitValue || null);
                          } else {
                            form.setFieldValue('deductionProductIds', null);
                            form.setFieldValue('deductionLimitValue', null);
                          }
                        }}>
                  {promoType.map((item, index) => (
                    <Option key={item.key} value={item.key} disabled={item.key === 'DISCOUNT_COUPON' && activityProductType !== 'SINGLE'}>
                      {item.description}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                name="promoStyle"
                label="优惠形式"
                className={`${styles.case_item} ${styles.case_label_required}`}
              >
                <Select placeholder="请选择" className={styles.case_item_select}>
                  {promoStyle.map((item, index) => (
                    <Option key={item.key} value={item.key}>
                      {item.description}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item name="minLimit" label="最小值" className={`${styles.case_item}`}>
                <InputNumber placeholder="请输入" className={styles.case_input_area} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item name="maxLimit" label="最大值" className={`${styles.case_item}`}>
                <InputNumber placeholder="请输入" className={styles.case_input_area} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                name="salePrice"
                label="销售价"
                className={`${styles.case_item} ${styles.case_label_required}`}
              >
                <InputNumber placeholder="请输入" className={styles.case_input_area} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                name="sendPackageRule"
                label="发包规则"
                className={`${styles.case_item} ${styles.case_label_required}`}
              >
                <Input placeholder="请输入" />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                name="limitType"
                label="限制类型"
                className={`${styles.case_item} ${styles.case_label_required}`}
              >
                <Select placeholder="请选择" className={styles.case_item_select} onChange={(value) => {
                  setLimitTypeValue(value);
                  // 切换类型时，限制值清空
                  form.setFieldsValue({
                    limitValue: undefined
                  });
                }}>
                  {limitType.map((item, index) => (
                    <Option key={item.key} value={item.key}>
                      {item.description}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                name="limitValue"
                label="限制值"
                hidden={limitTypeValue === 'UNLIMITED'}
                className={`${styles.case_item} ${styles.case_label_required}`}
              >
                <Input placeholder="请输入" />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                name="pmsLimitType"
                label="交付限制类型"
                className={`${styles.case_item} ${styles.case_label_required}`}
              >
                <Select placeholder="请选择" className={styles.case_item_select}>
                  {pmLimitType.map((item, index) => (
                    <Option key={item.key} value={item.key}>
                      {item.description}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                name="costBelong"
                label="活动成本归属"
                className={`${styles.case_item} ${styles.case_label_required}`}
              >
                <Select placeholder="请选择" className={styles.case_item_select}>
                  {activeCostBelongCode.map((item, index) => (
                    <Option key={item.key} value={item.key}>
                      {item.description}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                name="required"
                valuePropName={'checked'}
                label="是否必须"
                className={`${styles.case_item} ${styles.case_label_required}`}
              >
                <Switch />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item name="remark" className={`${styles.case_item}`} label="备注">
                <Input.TextArea autoSize={{ minRows: 4, maxRows: 8 }} placeholder="请输入" />
              </Form.Item>
            </Col>
          </Row>
          {promoTypeValue === 'DISCOUNT_COUPON' ? <Row>
            <Col span={24}>
              <Form.Item name="deductionProductIds" className={`${styles.case_item} ${styles.case_label_required}`}
                         label="选择可抵扣的产品">
                <DebounceSearchSelect fetchOptions={getProductManagementPage} label={'产品'} pageSize={20}
                                      fixedParams={{  prodType: 'PRODUCT_PACKAGE' }}
                                      fieldNames={{ label: 'prodName' }} query={{ids: editData.deductionProductIds}}
                                      mode={'multiple'}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item name="deductionLimitValue" className={`${styles.case_item} ${styles.case_label_required}`}
                         label="最高抵扣金额（元）">
                <InputNumber placeholder={"请输入"} style={{ width: '100%' }} precision={2} min={0.01} max={200000}/>
              </Form.Item>
            </Col>
          </Row> : null}
        </Form>
      </div>
      </Spin>
    </Drawer>
  );
};

export default AddOrEditForm;
